import React from "react"
import Heading from "../../common/Heading"
import "./team.css"
import { useLanguage } from "../../../context/LanguageContext"

const Team = () => {
  const { content } = useLanguage()
  const { team } = content.home

  return (
    <>
      <section className='team background'>
        <div className='container'>
          <Heading title={team.title} subtitle={team.subtitle} />

          <div className='content mtop grid3'>
            {team.items.map((item) => (
              <div className='box' key={`${item.name}-${item.address}-${item.list}`}>
                <button type='button' className='btn3'>
                  {item.list} {team.listingsLabel}
                </button>
                <div className='details'>
                  <div className='img'>
                    <img src={item.cover} alt={item.name} />
                    <i className='fa-solid fa-circle-check' aria-label={team.verifiedLabel}></i>
                  </div>
                  <i className='fa fa-location-dot'></i>
                  <label>{item.address}</label>
                  <h4>{item.name}</h4>

                  <ul>
                    {item.iconClasses.map((iconClass) => (
                      <li key={iconClass}>
                        <i className={iconClass}></i>
                      </li>
                    ))}
                  </ul>
                  <div className='button flex'>
                    <button type='button'>
                      <i className='fa fa-envelope'></i>
                      {team.messageButton}
                    </button>
                    <button type='button' className='btn4' aria-label={team.callButton}>
                      <i className='fa fa-phone-alt'></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default Team
